export const withdrawalSteps = {
  withdrawalStepsAccount: "Account",
  withdrawalStepsAmount: "Amount",
  withdrawalStepsWidthdraw: "Withdraw",
  withdrawalStepsError: "Withdrawal failed",
  withdrawalStepsErrorDesc_1: "You need to play at least 30% of the amount deposited to withdraw.",
  withdrawalStepsErrorDesc_2: "Your withdrawal has failed, please check your data or contact support.",
  withdrawalStepsErrorDesc_3: "Your account is not verified. A verification email has been sent to your email.",
  withdrawalStepsErrorDesc_4: "The amount is not within the allowed range.",
  withdrawalStepsSuccess: "Withdrawal successful",
  withdrawalStepsSuccessMessage: "Your withdrawal has been successfully processed.",
  emailVerificationSentTitle: "Email verification",
  emailVerificationSentMessage: "A verification email has been sent to your email. Please check your inbox.",
  emailVerificationErrorTitle: "Error sending verification",
  emailVerificationErrorMessage: "The verification email could not be sent. Please try again or contact support.",
  withdrawalStepsNext: "Next",
  withdrawalStepsBack: "Back",
  withdrawalStepsConfirm: "Confirm",
  withdrawalStepsCancel: "Cancel",

  // Content step 1,
  withdrawalStepsDailyWithdrawal: "Daily Withdrawal",
  withdrawalStepsWeeklyWithdrawal: "Weekly Withdrawal",
  withdrawalStepsWithdrawn: "Withdrawn",
  withdrawalStepsDailyRemaining: "Daily Remaining",
  withdrawalStepsWeeklyRemaining: "Weekly Remaining",
  withdrawalStepsSelectAccount: "Select your mobile payment account",
  withdrawalStepsSelectAccountDesc: "Please select your mobile payment account to proceed with the withdrawal.",
  withdrawalStepsSelectAccountDesc2: "If you haven't set up a mobile payment account yet, click ",
  withdrawalStepsSelectAccountlink: "here",
  withdrawalStepsSelectTitle: "Bank",
  withdrawalStepsSelectAccount_select: "Select an account",

  // step 1 modal
  withdrawalStepsModalLimitReachedTitle: "Limit Reached",
  withdrawalDayModalLimitReachedMessage:
    "You have reached the withdrawal limit for the day. Please try again tomorrow.",
  withdrawalWeekModalLimitReachedMessage:
    "You have reached the withdrawal limit for the week. Please try again next week.",
  withdrawalStepsModalLimitReachedButton: "Accept",

  // Content step 2,
  withdrawalSteps_2_Amount: "Enter the amount to withdraw",
  withdrawalSteps_2_AmountInput: "Enter amount",
  widthdrawalSteps_2_Error: "Invalid amount",
  withdrawalSteps_2_AmountError: "Enter a valid amount",
  widthdrawalSteps_2_Error2: "Insufficient balance",
  widthdrawalSteps_2_Error3: "Minimum amount 200 Bs",
  widthdrawalSteps_2_Error4: "Maximum amount 8,000 Bs daily",

  // Content step 3,
  withdrawalSteps_3_Confirm: "Withdrawal confirmation",
  withdrawalSteps_3_Bank: "Bank ",
  withdrawalSteps_3_PhoneNumber: "Phone number",
  withdrawalSteps_3_Amount: "Amount",
  withdrawalSteps_3_YouWillWithdraw: "You will withdraw",

  // Conditional form translations for withdrawals
  withdrawalExplanationTitle: "Personal Registration Required",
  withdrawalExplanationMessage:
    "To complete the withdrawal, you need to register your personal information (name, last name, ID, and phone number). This information is required to process your withdrawals securely.",
  registerAndWithdraw: "Register & Make Withdrawal",

  // BINANCE WITHDRAWAL
  binanceWithdrawalTitle: "Binance Withdrawal",
  binanceWithdrawalNetwork: "Network",
  binanceWithdrawalMinAmount: "Minimum Amount",
  binanceWithdrawalMaxAmount: "Maximum Amount",
  binanceWithdrawalCommission: "Commission",
  binanceWithdrawalAmountRequired: "Amount is required.",
  binanceWithdrawalAddress: "Wallet Address (TRC20)",
  binanceWithdrawalAddressModal: "Wallet Address",
  binanceWithdrawalAddressPlaceholder: "Enter wallet address (TRC20)",
  binanceWithdrawalAmount: "Amount to Withdraw",
  binanceWithdrawalAmountPlaceholder: "Enter amount to withdraw",
  binanceWithdrawalConfirmTitle: "Confirm Binance Withdrawal",
  binanceWithdrawalInputErrorNumber: "Only numbers and decimal point are allowed.",
  binanceWithdrawalInputErrorInvalid: "The amount is not valid.",
  binanceWithdrawalInputErrorMin: "The minimum amount is",
  binanceWithdrawalInputErrorMax: "The maximum amount is",
  binanceWithdrawalAddressErrorRequired: "Wallet address is required.",
  binanceWithdrawalAddressErrorStart: "Wallet address must start with 'T'.",
  binanceWithdrawalAddressErrorLength: "Wallet address must be 34 characters long.",
  binanceWithdrawalSuccessTitle: "Withdrawal Successful",
  binanceWithdrawalAmountCorrect: "Correct amount.",
  binanceWithdrawalAddressCorrect: "Correct address.",
  binanceWithdrawalContinueBtn: "Continue",
  binanceWithdrawalConfirmBtn: "Confirm",

  // Withdrawal success/failure modal states
  withdrawalSuccessTitle: "Withdrawal Requested!",
  withdrawalSuccessMessage:
    "Your withdrawal request has been successfully processed. You will receive the payment in your mobile payment account shortly.",
  withdrawalSuccessClose: "Close",
  withdrawalFailureTitle: "Withdrawal Failed",
  withdrawalFailureMessage: "We couldn't process your withdrawal request. Please review the details and try again.",
  withdrawalFailureRetry: "Retry",
  withdrawalFailureClose: "Close",
};
